module.exports = __webpack_public_path__ + "img/products_big_can_orange_ru.26fa0a30.png";